import { createContext, ReactNode, useContext } from 'react';

import { AdminWorkspaceContextData } from 'src/contracts/multiCompany/v1';
import { useAdminWorkspace } from './AdminWorkspaceProvider';

export interface CompanyProfileWorkspaceScope {
  actorId: number;
  role: 'COMPANY_ADMIN' | 'SUPER_ADMIN';
  accessLevel?: 'COMPANY_ADMIN' | 'OPERATIONS_MANAGER' | 'FINANCE_MANAGER';
  accessLevels?: Array<
    'COMPANY_ADMIN' | 'OPERATIONS_MANAGER' | 'FINANCE_MANAGER'
  >;
  company: AdminWorkspaceContextData['company'];
  routeBase: string;
}

const PlatformCompanyProfileScopeContext =
  createContext<CompanyProfileWorkspaceScope | null>(null);

export const PlatformCompanyProfileScopeProvider = ({
  scope,
  children
}: {
  scope: CompanyProfileWorkspaceScope;
  children: ReactNode;
}) => (
  <PlatformCompanyProfileScopeContext.Provider value={scope}>
    {children}
  </PlatformCompanyProfileScopeContext.Provider>
);

export const useCompanyProfileWorkspaceScope = () => {
  const platformScope = useContext(PlatformCompanyProfileScopeContext);
  const state = useAdminWorkspace();
  if (platformScope) return platformScope;
  return state.kind === 'company' && state.status === 'ready'
    ? state.workspace
    : null;
};
